<template>
    <div class="container" v-if="!fetching">
        <div class="section" v-for="(item, index) in imgList" :key="index">
            <img v-if="index < 2" class="img" :src="item">
            <div class="activityImg" v-if="activity.isShow && index == 0">
                <img :src="activity.H5activeImg">
            </div>
        </div>
        <div class="sw-section-1">
            <img class="title-img" :src="titleImg[0]">
            <div class="swiper-container current-wrap">
                <div class="swiper-wrapper">
                    <div class="swiper-slide current-slider" v-for="(item, index) in swiperList1" :key="index">
                        <img :src="item">
                    </div>
                </div>
                <div class="swiper-pagination current-pagination" />
            </div>
        </div>
         <div class="section" v-for="(item, index) in imgList" :key="index">
            <img v-if="index == 2" class="img" :src="item">
        </div>
        <div class="tab-section">
            <img class="title-img" :src="titleImg[1]">
             <div class="s-main">
                <van-tabs :swipe-threshold="4" v-model="active">
                    <van-tab v-for="(item, index) in (tabMain.stageList || [])" :key="index" :title="item.stage" class="tb">
                        <div class="t-title">
                            {{item.title}}
                        </div>
                        <img class="t-icon" src="https://s21.lgstatic.com/growth/activity/20210419/1618820076232.png">
                        <div class="target">
                            <div class="title">
                                <div class="target-link"></div>
                                <div class="text">学习目标</div>
                                <div class="btn" @click="showModal(item)"></div>
                            </div>
                            <div class="content">
                                <div v-for="(val,ind) in item.external.phaseTargetList" :key="ind" class="content-list">
                                    <div class="icon" :class="{'noicon':ind == item.external.phaseTargetList.length - 1}"></div>
                                    <div class="text">{{val}}</div>
                                </div>
                            </div>
                            <div class="title">
                                <div class="target-link"></div>
                                <div class="text">关键技术点</div>
                            </div>
                            <div class="content">
                                <div v-for="(val,ind) in item.external.skillsList" :key="ind" class="content-list">
                                    <div class="icon" :class="{'noicon':ind == item.external.skillsList.length - 1}"></div>
                                    <div class="text">{{val}}</div>
                                </div>
                            </div>
                        </div>
                    </van-tab>
                </van-tabs>
                <div class="tips-tab">
                    * 具体课程内容以实际课程安排和进度为准
                </div>
                <button class="btn-receive" @click="JumpFn">
                    <img :src="btnimgList.receive">
                </button>
            </div>





        </div>
        <div class="sw-section-2">
            <img class="title-img-1" :src="titleImg[2]">
            <img class="title-img-2" :src="titleImg[3]">
            <div class="swiper-container wrap-current">
                <div class="swiper-wrapper">
                    <div class="swiper-slide current-slider" v-for="(item, index) in swiperList2" :key="index">
                        <img :src="item">
                    </div>
                </div>
                <div class="swiper-pagination current-pagination" />
            </div>
        </div>
        <div class="btn-view">
            <button class="btn-more" @click="JumpFn">
                <img :src="btnimgList.getMore">
            </button>
        </div>
        <div class="section" v-for="(item, index) in imgList" :key="index">
            <img v-if="index < 6 && index > 2" class="img" :src="item">
        </div>
        <div class="sw-section-3">
            <img class="title-img" :src="titleImg[4]">
            <div class="swiper-container current">
                <div class="swiper-wrapper">
                    <div class="swiper-slide current-slider" v-for="(item, index) in swiperList3" :key="index">
                        <img :src="item">
                    </div>
                </div>
                <div class="swiper-pagination current-pagination" />
            </div>
        </div>
        <div class="section" v-for="(item, index) in imgList" :key="index">
            <img v-if="index == 6" class="img" :src="item">
        </div>
        <div class="section" >
            <img class="img" src="https://s20.lgstatic.com/growth/activity/20220316/1647399751975.png">
        </div>
        <template>
            <ClueFooter
                :bgStyle="{background: 'linear-gradient(90deg, #5159FF 0%, #428DF2 100%)'}"
                v-if="firstBtnType"
                @jump="JumpFn('亮片名额有限立即抢占')"
                />
                <button class="footer" @click="JumpFn" v-else>
                    <img v-if="isBView === 'A'" :src="btnimgList.footer">
                    <img v-if="isBView === 'B'" :src="btnimgList.footerB">
                    <img class="H5activityIcon" v-if="activity.isShow" :src="activity.H5icon">
                </button>
        </template>
        <div :class="{'modal-container': true, active: modalVisable}" v-if="modalVisable">
            <div :class="{'layer': true, active: modalVisable}"/>
            <div class="modal">
                <div class="modal-content active">
                    <div class="close-container">
                        <div
                            class="close"
                            @click="closeModal"
                        />
                    </div>
                    <div>
                        <div class="title">
                            {{ moadlData.title }}
                            <div class="sub-title">
                                {{ moadlData.stage }}
                            </div>
                        </div>
                        <div class="content">
                            <div class="title-1">
                                <div class="target-link"></div>
                                <div class="text">学习目标</div>
                            </div>
                            <div class="content-1">
                                <div v-for="(val,ind) in moadlData.inside.phaseTargetList" :key="ind" class="content-list">
                                    <div class="icon"></div>
                                    <div class="text">{{val}}</div>
                                </div>
                            </div>
                            <div class="title-1">
                                <div class="target-link"></div>
                                <div class="text">关键技术点</div>
                            </div>
                            <div class="content-1">
                                <div v-for="(val,ind) in moadlData.inside.skillsList" :key="ind" class="content-list">
                                    <div class="icon"></div>
                                    <div class="text">{{val}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { handleJumpUrl } from '../../../uitl/getParam.js';
import List from './list'
import Swiper from 'swiper';
import 'swiper/dist/css/swiper.min.css';
import activity from '../../../common/activity';
import { Tab, Tabs } from 'vant';
Vue.use(Tab);
Vue.use(Tabs);
export default {
    components: {
        [Tab.name]: Tab,
        [Tabs.name]: Tabs,
    },
    props: ['isBView'],
    data() {
        return {
            activity,
            List,
            active: 0,
            imgList:[],
            btnimgList:{},
            titleImg:[],
            swiperList1:[],
            swiperList2:[],
            swiperList3:[],
            tabMain:{},
            modalVisable:false,
            moadlData:{}
        }
    },
    created() {
        this.saLogin()
    },
    mounted () {
        setTimeout(()=>{
            this.eduPlatTrack('WebView', { page_id: '1s5n'});
        },500)
        let dataList = this.List.data.h5
        this.imgList = dataList.imgList
        this.btnimgList = dataList.btnimgList
        this.titleImg = dataList.titleImg
        this.swiperList1 = dataList.swiperList1
        this.swiperList2 = dataList.swiperList2
        this.swiperList3 = dataList.swiperList3
        this.tabMain = dataList.tabMain
        this.swiperInit()
    },
    methods: {
        JumpFn(name) {
            let button_name = (this.isBView === 'B' ? '免费领取vip月卡' : '抢先领取试学名额')
            if(name && typeof name ==='string'){
                button_name = name
            }
            this.eduPlatTrack('WebButtonClick', {
                'page_id': '1s5n',
                'button_name': button_name
            });
            // let key = this.isBView === 'B' ? '0b0a6bf8c4d145fab1130a9cbbfa483a' : 'bbf380b5983e4f1993f71606a8f3b3e6';
            let key = 'bbf380b5983e4f1993f71606a8f3b3e6';
            handleJumpUrl(key);
        },
        swiperInit() {
            let option = {
                direction: 'horizontal',
                loop: true,
                speed: 1400,
                autoplayDisableOnInteraction: false,
                autoplay: 2000,
                spaceBetween: 30,
                pagination: '.current-pagination',
            };
            let option1 = {
                direction: 'horizontal',
                loop: true,
                speed: 1400,
                autoplayDisableOnInteraction: false,
                autoplay: 1000,
                spaceBetween: 30,
                pagination: '.current-pagination',
            };
            this.$nextTick(() => {
                const swiper1 = new Swiper('.current-wrap', option1);
                const swiper2 = new Swiper('.wrap-current', option);
                const swiper3 = new Swiper('.current', option);
            });
        },
        closeModal(){
            this.looseBody();
            this.modalVisable = false;
        },
        fixedBody() {
            this.selfTop = document.body.scrollTop || document.documentElement.scrollTop;
            document.body.style.cssText += 'position:fixed;overflow: hidden;height: auto;top: -' + this.selfTop + 'px';
        },
        looseBody() {
            var body = document.body;
            body.style.overflow = 'auto';
            body.style.height = 'auto';
            body.style.position = '';
            document.body.scrollTop = document.documentElement.scrollTop = parseInt(this.selfTop);
        },
        showModal(item){
            console.log(item);
            this.fixedBody();
            this.modalVisable = true;
            this.moadlData = item
        },
    },
}
</script>

<style lang="less" scoped>
.container {
    width: 100%;
    background: #ECF5FF;
    padding-bottom: 200px;
    .section {
        position: relative;
        width: 100%;
        .img {
            width: 100%;
            display: block;
        }
        .activityImg {
            position: absolute;
            z-index: 11;
            top: 0;
            right: 0;
            width: 157px;
            height: 158px;
            img {
                width: 100%;
            }
        }
    }
    .sw-section-1 {
        width: 100%;
        position: relative;
        .title-img {
            display: block;
            width: 100%;
            margin:20px 0 20px;
        }
    }
    .sw-section-2 {
        width: 100%;
        position: relative;
        .title-img-1 {
            display: block;
            width: 100%;
            margin:40px 0 0px;
        }
        .title-img-2 {
            display: block;
            width: 100%;
            margin:0px 0 40px;
        }
    }
    .sw-section-3 {
        width: 100%;
        position: relative;
        .title-img {
            display: block;
            width: 100%;
            margin:0px 0 20px;
        }
    }
    .tab-section {
        width: 100%;
        position: relative;
        .title-img {
            display: block;
            width: 100%;
            margin:50px 0 20px;
        }
        .s-main {
            // position: relative;
            margin: 10px auto 0;
            width: 688px;
            background-color: #fff;
            z-index: 2;
            border-radius: 8px;
            padding-bottom: 100px;
            .tb {
                position: relative;
                width: 100%;
                background-color: #fff;
                .t-title {
                    text-align: center;
                    font-size: 32px;
                    color: #555;
                    font-weight: 500;
                    padding: 25px 0 10px;
                }
                .t-icon {
                    width: 688px;
                    display: block;
                    height: 2px;
                }
                .target {
                    color: #3D3D3F;
                    font-size: 26px;
                    margin-top: 35px;
                    .title {
                        display: flex;
                        height: 49px;
                        align-items: center;
                        font-weight: bold;
                        margin-bottom: 20px;
                    }
                    .target-link {
                        width: 6px;
                        height: 22px;
                        background: linear-gradient(313deg, #5159FF 0%, #4191F1 100%);
                        margin-left: 46px;
                        margin-right: 8px;
                    }
                    .text {
                        flex: 1;
                    }
                    .btn {
                        width: 151px;
                        height: 49px;
                        background: url('https://s21.lgstatic.com/growth/activity/20210421/1618972324397.png') no-repeat;
                        background-size: 100% 100%;
                        margin-right: 40px;
                    }
                    .content {
                        margin-top: 10px;
                    }
                    .content-list {
                        display: flex;
                        color: #595959;
                        line-height: 48px;
                        font-size: 24px;
                        .icon {
                            width: 8px;
                            height: 8px;
                            background: #5763FF;
                            border-radius: 50%;
                            margin-left: 46px;
                            margin-top: 20px;
                            margin-right: 8px;
                        }
                        .noicon {
                            background-color: #fff;
                        }
                        .text {
                            opacity: .7;
                            flex: 1;
                            width: 612px;
                            padding-right: 14px;
                        }
                    }
                }
            }
        }
        /deep/ .van-tabs__wrap--scrollable{
            height: 106px;
        }
        /deep/ .van-tabs__nav {
            background: linear-gradient(335deg, #4094F0 0%, #5159FF 100%);
            height: 106px;
        }
        /deep/ .van-tabs--line .van-tabs__wrap {
            border-top-left-radius: 8px;
            border-top-right-radius: 8px;
        }
        /deep/ .van-tab {
            width: 180px;
            height: 106px;
            color: #fff;
            font-size: 28px;
            font-weight: 400;
        }
        /deep/ .van-tabs__line {
            bottom: 40px;
            background: #fff;
            width: 64px;
            height: 6px;
        }
        .tips-tab {
            font-size: 14px;
            color: #666;
            position: absolute;
            bottom: 60px;
            right: 60px;
        }
        .btn-receive {
            position: absolute;
            bottom: -30px;
            left: 50%;
            transform: translate(-50%);
            background-color:transparent;
            border: none;
            z-index: 9;
            width: 488px;
            height: 76px;
            img {
                width: 100%;
                display: block;
            }
        }
    }
    .btn-view {
        width: 100%;
        height: 130px;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 22;
        .btn-more {
            background-color:transparent;
            border: none;
            z-index: 9;
            width: 488px;
            z-index: 111;
            img {
                width: 100%;
                display: block;
            }
        }
    }
    .footer {
        position: fixed;
        background-color:transparent;
        border: none;
        bottom: -1px;
        z-index: 999;
        width: 100%;
        img {
            width: 100%;
            display: block;
        }
        .H5activityIcon {
            position: absolute;
            top: -50px;
            right: 42px;
            width: 209px;
        }
    }
}

/deep/ .current-wrap {
    width: 9.173rem;
    height: 8.2rem;
    .swiper-wrapper {
        width: 9.173rem;
        img {
            width: 100%;
        }
    }
    .swiper-pagination-bullet {
        border-radius: 50%;
        width: 0.16rem;
        height: 0.173rem;
        background: #afafaf;
        opacity: 0.5;
        margin: 0 0.093rem;
        &-active {
            width: 0.48rem;
            height: 0.173rem;
            background: #afafaf;
            border-radius: 4px;
            opacity: 1;
        }
    }
}
/deep/ .wrap-current {
    width: 9.173rem;
    // height: 8.2rem;
    .swiper-wrapper {
        width: 9.173rem;
        img {
            width: 100%;
        }
    }
    .swiper-pagination-bullet {
        border-radius: 50%;
        width: 0.16rem;
        height: 0.173rem;
        background: #afafaf;
        opacity: 0.5;
        margin: 0 0.093rem;
        &-active {
            width: 0.48rem;
            height: 0.173rem;
            background: #afafaf;
            border-radius: 4px;
            opacity: 1;
        }
    }
}
/deep/ .current {
    width: 9.173rem;
    height: 5.5rem;
    .swiper-wrapper {
        width: 9.173rem;
        img {
            width: 100%;
        }
    }
    .swiper-pagination-bullet {
        border-radius: 50%;
        width: 0.16rem;
        height: 0.173rem;
        background: #afafaf;
        opacity: 0.5;
        margin: 0 0.093rem;
        &-active {
            width: 0.48rem;
            height: 0.173rem;
            background: #afafaf;
            border-radius: 4px;
            opacity: 1;
        }
    }
}
.layer {
    position: fixed;
    z-index: 9;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    background: rgba(0, 0, 0, 0.6);
    display: none;
    &.active {
        display: block;
    }
}
.modal {
    position: fixed;
    bottom: 139px;
    z-index: 10;
    display: flex;
    justify-content: center;
    .modal-content {
        width: 750px;
        height: 0;
        opacity: 0;
        transition: height .3s linear;
        overflow-y: scroll;
        &.active {
            opacity: 1;
            height: 962px;
            overflow: hidden;
        }
        background: #fff;
        border-radius: 18px 18px 0 0;
        position: relative;
        margin-right: 45px;
        box-sizing: border-box;
    }
    .close {
        width: 42px;
        height: 42px;
        background: url("https://s21.lgstatic.com/growth/activity/20210402/1617356751440.png") no-repeat;
        background-size: 42px 42px;
        position: absolute;
        right: 30px;
        top: 30px;
        border-radius: 50%;
        z-index: 1;
    }
    .title {
        margin-top: 82px;
        width: 658px;
        font-size: 32px;
        line-height: 40px;
        margin-bottom: 41px;
        padding-left: 45px;
        font-weight: bold;
        &-dot {
            width: 5px;
            height: 5px;
            border-radius: 5px;
            background: #FA4000;
        }
        .sub-title{
            color: #C69C6D;
            font-size: 26px;
            margin-top: 8px;
        }
    }
    .content {
        height: 755px;
        overflow-y: scroll;
        .title-1 {
            display: flex;
            height: 49px;
            align-items: center;
            font-weight: bold;
            font-size: 38px;
        }
        .target-link {
            width: 6px;
            height: 22px;
            background: linear-gradient(313deg, #5159FF 0%, #4191F1 100%);
            margin-left: 46px;
            margin-right: 8px;
        }
        .text {
            font-size: 28px;
            flex: 1;
            padding: 6px 0;
        }
        .content-list {
            display: flex;
            color: #595959;
            line-height: 48px;
            font-size: 24px;
            .icon {
                width: 8px;
                height: 8px;
                background: #5763FF;
                border-radius: 50%;
                margin-left: 46px;
                margin-top: 26px;
                margin-right: 8px;
            }
            .text {
                opacity: .7;
                flex: 1;
                width: 612px;
                padding-right: 14px;
                font-size: 22px;
            }
        }

    }

}
</style>